import { useContext, useEffect } from 'react';
import ConnectivityContext from '@/contexts/connectivity';

const useOnline = ({ onStatusChange } = {}) => {
  const value = useContext(ConnectivityContext);

  const { online } = value;

  useEffect(() => {
    if (onStatusChange) {
      onStatusChange({ online });
    }
  }, [online, onStatusChange]);

  return value;
};

export default useOnline;